import *  as yup from 'yup'

export const ordenServicioVisitaSchema = yup.object({
    persona_referencia_nombre: yup.string().required('El campo persona es requerida'),
    persona_referencia_parentesco: yup.string().required('El campo persona referencia parentesco es requerido'),
    persona_referencia_celular:yup.string().required('El campo referencia celular es requerido'),
    celular: yup.string().required('El campo celular es requerido'),
    celular_2:yup.string().optional(),
    estado_llmada:yup.string().optional(),
    observacion_llamada:yup.string().optional(),
    isRejecting: yup.boolean().optional().nullable(),
    motivo_rechazo:yup.string().nullable().when('isRejecting',{
        is:true,
        then:schema => schema.required('El campo motivo rechazo es requerido'),
    })
  /*   coordenadas: yup.string().required('campo obligatorio'),
    direccion: yup.string()
        .min(20, 'La dirección debe tener al menos 20 caracteres')
        .matches(
            /^[^_-]*$/,
            'No se permiten guiones (-) ni guiones bajos (_)'
        )
        .required('campo obligatorio'),
    tipo_orden_servicio: yup.string().required('campo obligatorio'),
    provincia: yup.string().required('campo obligatorio'),
    ciudad: yup.string().required('campo obligatorio'),
    sector: yup.string().required('campo obligatorio'),
    zona: yup.string().required('campo obligatorio'),
    parroquia: yup.string().required('campo obligatorio'), */
})